export interface EgonLocation {
  id: string;
  name: string;
  address: string;
  city: string;
  fullAddress: string;
}

export const egonLocations: EgonLocation[] = [
  {
    id: "arendal",
    name: "Arendal",
    address: "Friergangen 1",
    city: "Arendal",
    fullAddress: "Friergangen 1, 4836 Arendal"
  },
  {
    id: "asker",
    name: "Asker",
    address: "Torvveien 1",
    city: "Asker",
    fullAddress: "Torvveien 1, 1383 Asker"
  },
  {
    id: "bodo",
    name: "Bodø",
    address: "Moloveien 14",
    city: "Bodø",
    fullAddress: "Moloveien 14, 8003 Bodø"
  },
  {
    id: "bristol",
    name: "Bristol",
    address: "Torgallmenningen 11",
    city: "Bergen",
    fullAddress: "Torgallmenningen 11, 5014 Bergen"
  },
  {
    id: "city-syd",
    name: "City Syd",
    address: "Østre Rosten 28",
    city: "Tiller",
    fullAddress: "Østre Rosten 28, 7075 Tiller"
  },
  {
    id: "drammen",
    name: "Drammen",
    address: "Bragernes Torg 13",
    city: "Drammen",
    fullAddress: "Bragernes Torg 13, 3017 Drammen"
  },
  {
    id: "fredrikstad",
    name: "Fredrikstad",
    address: "Nygaardsgata 50",
    city: "Fredrikstad",
    fullAddress: "Nygaardsgata 50, 1607 Fredrikstad"
  },
  {
    id: "gjovik",
    name: "Gjøvik",
    address: "Jernbanegata 5",
    city: "Gjøvik",
    fullAddress: "Jernbanegata 5, 2821 Gjøvik"
  },
  {
    id: "gulskogen",
    name: "Gulskogen",
    address: "Guldlisten 35",
    city: "Drammen",
    fullAddress: "Guldlisten 35, 3048 Drammen"
  },
  {
    id: "hamar",
    name: "Hamar",
    address: "Torggata 83",
    city: "Hamar",
    fullAddress: "Torggata 83, 2317 Hamar"
  },
  {
    id: "harstad",
    name: "Harstad",
    address: "Sjøgata 11",
    city: "Harstad",
    fullAddress: "Sjøgata 11, 9405 Harstad"
  },
  {
    id: "haugesund",
    name: "Haugesund",
    address: "Smedasundet 93",
    city: "Haugesund",
    fullAddress: "Smedasundet 93, 5527 Haugesund"
  },
  {
    id: "jekta",
    name: "Jekta",
    address: "Karlsøyvegen 12",
    city: "Tromsø",
    fullAddress: "Karlsøyvegen 12, 9015 Tromsø"
  },
  {
    id: "jessheim",
    name: "Jessheim",
    address: "Furusethgata 5",
    city: "Jessheim",
    fullAddress: "Furusethgata 5, 2050 Jessheim"
  },
  {
    id: "karl-johan",
    name: "Karl Johan",
    address: "Karl Johans gate 37",
    city: "Oslo",
    fullAddress: "Karl Johans gate 37, 0162 Oslo"
  },
  {
    id: "kristiansand",
    name: "Kristiansand",
    address: "Markensgate 39",
    city: "Kristiansand",
    fullAddress: "Markensgate 39, 4612 Kristiansand"
  },
  {
    id: "kjottbasaren",
    name: "Kjøttbasaren",
    address: "Vetrlidsallmenningen 2",
    city: "Bergen",
    fullAddress: "Vetrlidsallmenningen 2, 5014 Bergen"
  },
  {
    id: "lade",
    name: "Lade",
    address: "Haakon VIIs gate 9",
    city: "Trondheim",
    fullAddress: "Haakon VIIs gate 9, 7041 Trondheim"
  },
  {
    id: "lagunen",
    name: "Lagunen",
    address: "Laguneveien 1",
    city: "Rådal",
    fullAddress: "Laguneveien 1, 5239 Rådal"
  },
  {
    id: "lillestrom",
    name: "Lillestrøm",
    address: "Storgata 25",
    city: "Lillestrøm",
    fullAddress: "Storgata 25, 2000 Lillestrøm"
  },
  {
    id: "lillehammer",
    name: "Lillehammer",
    address: "Elvegaten 12",
    city: "Lillehammer",
    fullAddress: "Elvegaten 12, 2609 Lillehammer"
  },
  {
    id: "lorenskog",
    name: "Lørenskog",
    address: "Gamleveien 88",
    city: "Rasta (Lørenskog)",
    fullAddress: "Gamleveien 88, 1476 Rasta (Lørenskog)"
  },
  {
    id: "molde",
    name: "Molde",
    address: "Storgata 8",
    city: "Molde",
    fullAddress: "Storgata 8, 6413 Molde"
  },
  {
    id: "moa",
    name: "Moa",
    address: "Langelandsvegen 25",
    city: "Ålesund",
    fullAddress: "Langelandsvegen 25, 6010 Ålesund"
  },
  {
    id: "nordstrand",
    name: "Nordstrand",
    address: "Ekebergveien 228 B",
    city: "Oslo",
    fullAddress: "Ekebergveien 228 B, 1162 Oslo"
  },
  {
    id: "porsgrunn",
    name: "Porsgrunn",
    address: "Kulltangvegen 70",
    city: "Porsgrunn",
    fullAddress: "Kulltangvegen 70, 3921 Porsgrunn"
  },
  {
    id: "prinsen",
    name: "Prinsen",
    address: "Kongens gate 30",
    city: "Trondheim",
    fullAddress: "Kongens gate 30, 7011 Trondheim"
  },
  {
    id: "sandnes",
    name: "Sandnes",
    address: "Vågsgata 33",
    city: "Sandnes",
    fullAddress: "Vågsgata 33, 4306 Sandnes"
  },
  {
    id: "sandvika",
    name: "Sandvika",
    address: "Kinoveien 11",
    city: "Sandvika",
    fullAddress: "Kinoveien 11, 1338 Sandvika"
  },
  {
    id: "sarpsborg",
    name: "Sarpsborg",
    address: "Roald Amundsens gate 36",
    city: "Sarpsborg",
    fullAddress: "Roald Amundsens gate 36, 1723 Sarpsborg"
  },
  {
    id: "ski",
    name: "Ski",
    address: "Jernbaneveien 10",
    city: "Ski",
    fullAddress: "Jernbaneveien 10, 1400 Ski"
  },
  {
    id: "solsiden",
    name: "Solsiden",
    address: "TMV-Kaia 21",
    city: "Trondheim",
    fullAddress: "TMV-Kaia 21, 7043 Trondheim"
  },
  {
    id: "sartor",
    name: "Sartor",
    address: "Sartorvegen 12",
    city: "Straume",
    fullAddress: "Sartorvegen 12, 5353 Straume"
  },
  {
    id: "stjordal",
    name: "Stjørdal",
    address: "Kjøpmannsgata 29 B",
    city: "Stjørdal",
    fullAddress: "Kjøpmannsgata 29 B, 7500 Stjørdal"
  },
  {
    id: "storo",
    name: "Storo",
    address: "Vitaminveien 9–11",
    city: "Oslo",
    fullAddress: "Vitaminveien 9–11, 0485 Oslo"
  },
  {
    id: "strommen",
    name: "Strømmen",
    address: "Støperiveien 5",
    city: "Strømmen",
    fullAddress: "Støperiveien 5, 2010 Strømmen"
  },
  {
    id: "tarnet",
    name: "Tårnet",
    address: "Otto Nielsens veg 4",
    city: "Trondheim",
    fullAddress: "Otto Nielsens veg 4, 7052 Trondheim"
  },
  {
    id: "tromso",
    name: "Tromsø",
    address: "Storgata 50",
    city: "Tromsø",
    fullAddress: "Storgata 50, 9008 Tromsø"
  },
  {
    id: "ullevaal",
    name: "Ullevål",
    address: "Sognsveien 77C",
    city: "Oslo",
    fullAddress: "Sognsveien 77C, 0855 Oslo"
  },
  {
    id: "alesund",
    name: "Ålesund",
    address: "Løvenvoldgt. 8",
    city: "Ålesund",
    fullAddress: "Løvenvoldgt. 8, 6002 Ålesund"
  },
  {
    id: "asane",
    name: "Åsane",
    address: "Myrdalsvegen 2",
    city: "Nyborg",
    fullAddress: "Myrdalsvegen 2, 5130 Nyborg"
  },
  {
    id: "byporten",
    name: "Byporten",
    address: "Jernbanetorget 6",
    city: "Oslo",
    fullAddress: "Jernbanetorget 6, 0154 Oslo"
  },
  {
    id: "stavanger",
    name: "Stavanger",
    address: "Strandkaien 2",
    city: "Stavanger",
    fullAddress: "Strandkaien 2, 4005 Stavanger"
  }
];